// components/BotonesAccion.js
import { Box, Button } from '@mui/material';

export const BotonesAccion = ({ 
  onCancelar,
  onFinalizar,  // Nueva prop
  disabled,
  diferenciaPendiente
}) => {
  const esIgual = Math.abs(diferenciaPendiente) <= 0.01;
  
  return (
    <Box display="flex" justifyContent="flex-end" gap={2} mt={3}>
      <Button variant="outlined" onClick={onCancelar}>
        Volver
      </Button>
      
      <Button 
        variant="contained" 
        color="primary"
        onClick={onFinalizar}
        disabled={disabled || !esIgual}
        title={!esIgual ? "Los pagos deben igualar el total de la factura" : ""}
      >
        Guardar
      </Button>
    </Box>
  );
};